import React, { FC } from 'react';
import { modalsSlice } from 'data/store/modalReducer';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import useGlobalTranslation from 'hooks/useGlobalTranlation';
import ConfirmationModal from 'components/common/ConfirmationModal';

const ArchiveBilag: FC = () => {
  const { archiveBilag } = useAppSelector((state) => state.modals);
  const { closeArchiveBilag } = modalsSlice.actions;
  const dispatch = useAppDispatch();
  const { t } = useGlobalTranslation('archiveBilag');

  return (
    <ConfirmationModal
      isConfirm
      isOpen={!!archiveBilag?.show}
      title={t('title')}
      text={t('text')}
      cancelButtonProps={{
        onClick: () => dispatch(closeArchiveBilag()),
        children: t('cancel')
      }}
      confirmButtonProps={{
        onClick: (onClose) => {
          if (archiveBilag?.functionConfirm) {
            archiveBilag.functionConfirm();
          }
          onClose();
        },
        children: t('submit')
      }}
    />
  );
};

export default ArchiveBilag;
